import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'currencyFormat',
})
export class CurrencyFormatPipe implements PipeTransform {

    transform(value: number, mode: 'BRL') {
        let result;
        switch (mode) {
            case 'BRL':
                const valBrl = value as number;
                result = (valBrl+((valBrl+'').includes('.') ? '' : ',')).replace('.', ',');
                let lengthAfterComma: number = result.substr(result.indexOf(',')).length;
                while(lengthAfterComma < 3) {
                    result += '0';
                    lengthAfterComma++;
                }
                break;
        
            default:
                result = this.transform(value, 'BRL')
                break;
        }
        return result
    }
}